import { parse } from "regexparam";

// The router and HTTP fallback share these patterns, including redirects and
// feature-gated routes. Authentication is deliberately not part of matching.
export const CLIENT_ROUTES = {
  home: "/",
  auth: "/auth",
  pricing: "/pricing",
  terms: "/terms",
  privacy: "/privacy",
  employerGuide: "/employer-guide",
  walinzi: "/walinzi",
  deleteAccount: "/delete-account",
  about: "/about",
  contact: "/contact",
  trialSignup: "/trial-signup",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  dashboard: "/dashboard",
  setup: "/setup",
  patrols: "/patrols",
  patrolDetail: "/guard-history/:id",
  guardHistory: "/guard-history",
  shiftScheduling: "/shift-scheduling",
  profile: "/profile",
  adminDashboard: "/admin-dashboard",
  adminCompany: "/admin/company/:id",
  billing: "/billing",
  internalManagement: "/internal-management",
  customerManagement: "/customer-management",
} as const;

export const CLIENT_ROUTE_PATTERNS = Object.values(CLIENT_ROUTES);
// regexparam is also Wouter's default parser: full-pattern, case-insensitive,
// optional single trailing slash, and nonempty dynamic segments.
const matchers = CLIENT_ROUTE_PATTERNS.map((pattern) => parse(pattern).pattern);

export function clientPathname(requestUrl: string): string {
  try {
    return decodeURI(new URL(requestUrl, "http://routes.invalid").pathname);
  } catch {
    return "";
  }
}

export function isClientRoute(requestUrl: string): boolean {
  const pathname = clientPathname(requestUrl);
  return matchers.some((matcher) => matcher.test(pathname));
}

export function isAssetRequest(requestUrl: string): boolean {
  const pathname = clientPathname(requestUrl);
  // Valid dynamic IDs may contain dots; recognised routes take priority.
  return !isClientRoute(requestUrl) && (
    /^\/(?:assets|fonts|images|src|node_modules)(?:\/|$)/i.test(pathname) ||
    /\/[^/]+\.[^/]+$/.test(pathname)
  );
}
